import { EarbudsRounded } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { useContext, useState } from "react";
import { FieldsSettingsContext } from "../../CustomNotificationPage";
import { field_IDs_mapping } from "../../fieldMapping";
import SettingsList from "../components/SettingsList";
import SettingsSection from "../components/SettingsSection";

export default function ScenariosNotificationsSection() {
  const [fetchStatus, setFetchStatus] = useState(null);
  const getFieldsSettingsData = useContext(FieldsSettingsContext);

  const scenariosFields = field_IDs_mapping.SCENARIOS;

  const settingsFieldIDs = [scenariosFields.NEW_SCENARIO_SET];

  const settingsData = getFieldsSettingsData(settingsFieldIDs);

  return (
    <SettingsSection
      title="Attack Surface"
      Icon={EarbudsRounded}
      fetchStatus={fetchStatus}
      setFetchStatus={setFetchStatus}
    >
      <Grid container direction="column" gap={0.5}>
        <Grid item mb={1}>
          <SettingsList
            settingsData={settingsData}
            setFetchStatus={setFetchStatus}
          />
        </Grid>
      </Grid>
    </SettingsSection>
  );
}
